import * as actions from '../actions/actionTypes';
import initialState from './initialState';

/**
 * This reducer handles the LOAD_REITS_SUCCESS action and sets an array of REITs in the store
 * @param {Array} [state] The REITs currently in the store, or the initial state of REITs
 * @param {Object} action The action to be handled
 * @returns {Array} The REITs
 */
export default function reits(state = initialState.reits, action) {
  switch (action.type) {
    case actions.LOAD_REITS_SUCCESS:
      return action.reits;
    case actions.LOAD_CLIENTS_SUCCESS:
    case actions.UNLOAD_CLIENT:
      return initialState.reits;
    default:
      return state;
  }
}
